import { GraphQLClient } from 'graphql-request'
import { csrfToken } from 'CanExConfig/axios'
import baseUrl from './baseUrl'

const graphQLRequest = (query, variables, endpoint = '/graphql') => {
  const baseURL = baseUrl()
  try {
    const headers = { 'X-CSRF-Token': csrfToken }
    const client = new GraphQLClient(new URL(endpoint, baseURL), {
      headers,
      credentials: 'include',
    })
    return client.request(query, variables)
  } catch (err) {
    throw new Error(err)
  }
}

export default graphQLRequest
